import React from 'react'
import DateTimePicker from 'react-datetime-picker'

export default function DatetimeCal(props) {
    return (
        <div className="dtp-row" style={{ direction: 'rtl' }}>
            {props.label && (
                <div className="dtp-label">{props.label}</div>
            )}
            <DateTimePicker
                className="calendarClass dtp-input"
                locale="ar-IQ"
                format="y/MM/dd HH:mm"
                disableClock={true}
                onChange={props.onChangeMethod}
                value={props.val}
            />
        </div>
    )
}
